<template>
    <div class="loginbg" id="login-main-hr">
        <div class="container">
            <div class="row">
                <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
                    <div class="loginform">
                        <div class="loginlogo">
                            <img src="static/images/login-logo.png" alt="Velocity Vehicle Group">
                        </div>
                        <h1 style="color:white;">
                            404 - Page Not Found
                        </h1>
                        <p style="color:white;">
                            The page you are looking for does not exist.
                        </p>
                        <button  id="loginbtn" type="submit" class="btn btn-primary" v-on:click.prevent="checkLocalStorage(this)">Go back to Home</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    var self;
    export default {
        name: 'NotFound',
        data() {
            return {
            }
        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            $('#main-header').hide();
            $('#sidebar-wrapper').hide();
            $("#wrapper").addClass("login-div-full");

            $(".loginbg").show();
        },
        methods: {
            checkLocalStorage: function() {
                if(localStorage.getItem('user_obj')) {
                    window.location.href = '/dashboard';
                } else if (localStorage.getItem('customer_obj')) {
                    window.location.href = '/customer/dashboard';
                } else {
                    window.location.href = '/';
                }
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/NotFound.vue